"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultRenderStreamingConfiguration = void 0;
exports.DefaultRenderStreamingConfiguration = {
    healthcheck: {
        attempts: 10,
        attemptInterval: 100
    },
    signaling: {
        domain: "127.0.0.1"
    },
    matchmaker: {
        enabled: true,
        domain: "localhost",
        port: 3000,
        secure: false
    },
    peer: {
        polite: true,
        resendIntervalMs: 10000,
        ice: {
            sdpSemantics: 'unified-plan',
            iceServers: [
                {
                    urls: ['stun:stun.l.google.com:19302'],
                }
            ]
        }
    },
    videoPlayer: {
        container: "#player",
        id: "renderStreamingVideo",
        disableTouchAction: false,
        startMuted: true
    },
};
